import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65378243"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-resume-modal-content h-100" }
const _hoisted_2 = { class: "progress-steps" }
const _hoisted_3 = { class: "step-number" }
const _hoisted_4 = {
  key: 0,
  class: "bi bi-check-lg"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "step-label" }
const _hoisted_7 = {
  key: 0,
  class: "step-container"
}
const _hoisted_8 = { class: "source-options" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Import from file"),
  /*#__PURE__*/_createElementVNode("p", null, "Upload an existing resume in PDF or Word format")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right source-option-arrow" }, null, -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-plus" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Start from scratch"),
  /*#__PURE__*/_createElementVNode("p", null, "Create a new resume with our guided builder")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right source-option-arrow" }, null, -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-linkedin" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "source-option-content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Import from LinkedIn"),
  /*#__PURE__*/_createElementVNode("p", null, "Import your profile data directly from LinkedIn")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right source-option-arrow" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coming-soon-badge" }, "Coming Soon", -1))
const _hoisted_21 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "step-container file-upload-step"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "upload-content text-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-animation" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1))
const _hoisted_26 = {
  key: 1,
  class: "upload-content text-center"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-animation" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Resume uploaded successfully!", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "Ready to proceed to the next step", -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 2,
  class: "upload-content text-center"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-animation" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload" })
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Drag and drop your resume here", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-2" }, "or", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up me-2" }),
  /*#__PURE__*/_createTextVNode(" Choose File ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 small text-muted" }, "Supported formats: PDF, Word (.doc, .docx)", -1))
const _hoisted_37 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "selected-file mt-3"
}
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text me-2" }, null, -1))
const _hoisted_41 = { class: "flex-grow-1" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 2,
  class: "step-container template-selection-step"
}
const _hoisted_46 = { class: "form-group floating-label mb-4" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "resumeName" }, "Resume Name", -1))
const _hoisted_48 = { class: "templates-grid" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "template-preview" }
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "template-selected-indicator" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill" })
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fst-italic" }, "Don't worry - you can change the template style later", -1))
const _hoisted_54 = { class: "modal-footer-container" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-2" }, null, -1))
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_62 = {
  key: 1,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_63 = {
  key: 0,
  class: "bi bi-arrow-right"
}

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { ResumeTemplates } from "../../data/Templates";
import { TemplateOptions } from "../../../../server/src/models/dtos/ResponseDtos";
import { DocumentApiService } from "../../services/DocumentApiService";
import { ApplicationApiService } from "../../services/ApplicationApiService";
import type { UserApplicationListItem } from "../../../../server/src/models/dtos/UserApplicationList";
import type { ResumeListItem } from "../../../../server/src/models/dtos/ResumesList";
import { toast } from "vue3-toastify";
import type DocumentDto from "../../../../server/src/models/dtos/DocumentDto";
import type { Resume } from "../../../../server/src/models/Resume";
import ResumeDropdown from "./ResumeDropdown.vue";
import Modal from "../../components/Modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateResumeModal',
  setup(__props, { expose: __expose }) {

const router = useRouter();
const modalRef = ref<InstanceType<typeof Modal> | null>(null);

// State variables for the modal
const currentStep = ref(1);
const newResumeName = ref("");
const importSource = ref<"scratch" | "linkedin" | "existing">("existing");
const applications = ref<UserApplicationListItem[]>([]);
const selectedApplicationId = ref<string | null>(null);
const jobTitle = ref("");
const jobDescription = ref("");
const selectedTemplate = ref<TemplateOptions>(TemplateOptions.RESUME_CLASSIC);
const loadingApplications = ref(false);
const fileInput = ref<HTMLInputElement | null>(null);
const selectedFile = ref<File | null>(null);
const uploadedDocumentId = ref<string | null>(null);
const isUploading = ref(false);
const currentLoadingMessage = ref("");
const uploadSuccess = ref(false);
const resumes = ref<ResumeListItem[]>([]);
const selectedResumeId = ref<string | null>(null);
const loadingResumes = ref(false);

// Add this constant for loading messages
const UPLOAD_MESSAGES = [
  "Analyzing document structure...",
  "Extracting work experience...",
  "Parsing educational background...",
  "Processing skills and certifications...",
  "Identifying contact information...",
  "Extracting professional summary...",
  "Processing achievements...",
  "Analyzing document formatting...",
  "Organizing extracted data...",
  "Finalizing resume import...",
];

// Computed properties for step management
const maxSteps = computed(() => (importSource.value === "existing" ? 3 : 2));

const isLastStep = computed(() => {
  return importSource.value === "existing" ? currentStep.value === 3 : currentStep.value === 2;
});

const canProceed = computed(() => {
  if (currentStep.value === 1) {
    return importSource.value !== null;
  }
  if (currentStep.value === 2 && importSource.value === "existing") {
    return selectedFile.value !== null && uploadedDocumentId.value !== null;
  }
  return true;
});

// Initialize modal on mount
onMounted(() => {
  fetchResumes();
});

// Methods
function show() {
  resetForm();
  modalRef.value?.show();
}

function hide() {
  modalRef.value?.hide();
}

function resetForm() {
  currentStep.value = 1;
  newResumeName.value = "";
  importSource.value = "existing";
  selectedApplicationId.value = null;
  jobTitle.value = "";
  jobDescription.value = "";
  selectedTemplate.value = TemplateOptions.RESUME_CLASSIC;
  selectedFile.value = null;
  uploadedDocumentId.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
}

async function fetchApplications() {
  loadingApplications.value = true;
  try {
    const response = await ApplicationApiService.getUserApplicationList();
    applications.value = response.data.applications;
  } catch (error) {
    console.error("Error fetching applications:", error);
    toast.error("Failed to load applications");
  } finally {
    loadingApplications.value = false;
  }
}

function nextStep() {
  if (currentStep.value < maxSteps.value) {
    currentStep.value++;
  } else {
    handleCreateResume();
  }
}

function prevStep() {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
}

// Add helper function for default name generation
function getDefaultResumeName(): string {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  });
  return `Resume ${formattedDate}`;
}

async function handleCreateResume() {
  const resumeName = newResumeName.value.trim() || getDefaultResumeName();

  try {
    let resumeId;

    if (importSource.value === "existing" && uploadedDocumentId.value) {
      // For imported resumes, just update the name and template
      const getResumeResponse = await DocumentApiService.getUserResume(uploadedDocumentId.value);
      const resume = getResumeResponse.data as Resume;

      const updatedResume: Resume = {
        ...resume,
        template: selectedTemplate.value,
        name: resumeName,
      };

      await DocumentApiService.updateUserResume(updatedResume);
      resumeId = uploadedDocumentId.value;
    } else {
      // Create new resume from scratch
      const response = await DocumentApiService.createResume({
        name: resumeName,
      });
      resumeId = response.data;

      if (resumeId) {
        // Get the resume we just created
        const getResumeResponse = await DocumentApiService.getUserResume(resumeId);
        const resume = getResumeResponse.data as Resume;

        // Update the resume with the template and other fields
        const updatedResume: Resume = {
          ...resume,
          template: selectedTemplate.value,
          name: resumeName,
          contactInfo: {
            firstName: "",
            surname: "",
            email: "",
            phone: "",
            location: "",
            linkedin: "",
            websiteOrPortfolio: "",
          },
          summary: {
            title: "",
            description: "",
          },
          workExperience: [],
          education: [],
          activities: [],
          certifications: [],
          additionalSkills: [],
          projects: [],
          languages: [],
          interests: [],
        };

        await DocumentApiService.updateUserResume(updatedResume);
      }
    }

    hide();
    resetForm();

    await router.push({
      name: "EditResume",
      params: { id: resumeId },
    });

    toast.success("Resume created successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } catch (error) {
    console.error("Error creating resume:", error);
    toast.error("Failed to create resume. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  }
}

// Methods for file handling
function triggerFileInput() {
  fileInput.value?.click();
}

async function handleFileSelect(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files?.length) {
    selectedFile.value = input.files[0];
    await uploadDocument();
  }
}

async function handleFileDrop(event: DragEvent) {
  const files = event.dataTransfer?.files;
  if (files?.length) {
    selectedFile.value = files[0];
    await uploadDocument();
  }
}

// Add this method to handle loading message rotation
function startLoadingMessages() {
  let index = 0;
  currentLoadingMessage.value = UPLOAD_MESSAGES[0];

  const interval = setInterval(() => {
    index = (index + 1) % UPLOAD_MESSAGES.length;
    currentLoadingMessage.value = UPLOAD_MESSAGES[index];
  }, 1000);

  return interval;
}

// Update the upload document method
async function uploadDocument() {
  if (!selectedFile.value) return;

  isUploading.value = true;
  uploadSuccess.value = false;
  const messageInterval = startLoadingMessages();

  try {
    const formData = new FormData();
    formData.append("file", selectedFile.value);

    const uploadResponse = await DocumentApiService.uploadResume(formData);
    const resume = uploadResponse.data;
    // Ensure id is a string before assigning
    if (resume && typeof resume.id === "string") {
      uploadedDocumentId.value = resume.id;
      uploadSuccess.value = true;

      toast.success("Document uploaded successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    } else {
      throw new Error("Invalid resume ID received");
    }
  } catch (error) {
    console.error("Error uploading document:", error);
    toast.error("Failed to upload document. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
    removeFile();
  } finally {
    clearInterval(messageInterval);
    isUploading.value = false;
    currentLoadingMessage.value = "";
  }
}

function removeFile() {
  selectedFile.value = null;
  uploadedDocumentId.value = null;
  uploadSuccess.value = false;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
}

function selectImportSource(source: "scratch" | "linkedin" | "existing") {
  importSource.value = source;
  // Reset file if changing from existing
  if (source !== "existing") {
    selectedFile.value = null;
  }
}

function getStepLabel(step: number) {
  if (importSource.value === "existing") {
    switch (step) {
      case 1:
        return "Resume Details";
      case 2:
        return "Upload File";
      case 3:
        return "Template";
      default:
        return "";
    }
  } else {
    switch (step) {
      case 1:
        return "Resume Details";
      case 2:
        return "Template";
      default:
        return "";
    }
  }
}

// Add function to fetch resumes
async function fetchResumes() {
  loadingResumes.value = true;
  try {
    const response = await DocumentApiService.getUserResumes();
    resumes.value = response.data.map((resume: any) => ({
      ...resume,
      id: resume.id || crypto.randomUUID(),
      name: resume.name || "Untitled Resume",
      lastModified: resume.lastModified ? new Date(resume.lastModified) : new Date(),
      previewUrl: resume.previewUrl || null,
    }));
  } catch (error) {
    console.error("Error fetching resumes:", error);
    toast.error("Failed to load resumes");
  } finally {
    loadingResumes.value = false;
  }
}

// Add function to handle resume selection
async function handleResumeSelect(resumeId: string) {
  const resume = resumes.value.find((r: ResumeListItem) => r.id === resumeId);
  if (resume) {
    uploadedDocumentId.value = resumeId as string;
    uploadSuccess.value = true;
    toast.success("Resume selected successfully!");
  }
}

// Expose methods to parent
__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    modalLg: "",
    hideFooter: "",
    hideTitle: "",
    hideCloseButton: ""
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxSteps.value, (step) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step,
              class: _normalizeClass(["progress-step", {
              active: currentStep.value === step,
              completed: currentStep.value > step,
            }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                (currentStep.value > step)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(step), 1))
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(getStepLabel(step)), 1)
            ], 2))
          }), 128))
        ]),
        (currentStep.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["source-option", { selected: importSource.value === 'existing' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectImportSource('existing')))
                }, _hoisted_12, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["source-option", { selected: importSource.value === 'scratch' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectImportSource('scratch')))
                }, _hoisted_16, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["source-option disabled", { selected: importSource.value === 'linkedin' }])
                }, _hoisted_21, 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (currentStep.value === 2 && importSource.value === 'existing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", {
                class: _normalizeClass(["upload-zone", { success: uploadSuccess.value }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (!uploadSuccess.value && triggerFileInput())),
                onDrop: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (!uploadSuccess.value && handleFileDrop($event)), ["prevent"])),
                onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                style: _normalizeStyle({ cursor: uploadSuccess.value ? 'default' : 'pointer' })
              }, [
                _createElementVNode("input", {
                  type: "file",
                  ref_key: "fileInput",
                  ref: fileInput,
                  class: "d-none",
                  accept: ".pdf,.doc,.docx",
                  onChange: handleFileSelect,
                  disabled: uploadSuccess.value
                }, null, 40, _hoisted_23),
                (isUploading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("h6", null, _toDisplayString(currentLoadingMessage.value), 1)
                    ]))
                  : (uploadSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_37))
              ], 38),
              (selectedFile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, _toDisplayString(selectedFile.value.name), 1),
                      _createElementVNode("button", {
                        class: "btn btn-link text-danger p-0",
                        onClick: removeFile,
                        disabled: isUploading.value
                      }, _hoisted_44, 8, _hoisted_42)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            (currentStep.value === 2 && importSource.value !== 'existing') ||
            (currentStep.value === 3 && importSource.value === 'existing')
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "resumeName",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newResumeName).value = $event)),
                  placeholder: " "
                }, null, 512), [
                  [_vModelText, newResumeName.value]
                ]),
                _hoisted_47
              ]),
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ResumeTemplates), (template) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: template.template,
                    class: _normalizeClass(["template-card", { selected: selectedTemplate.value === template.template }]),
                    onClick: ($event: any) => (selectedTemplate.value = template.template)
                  }, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("img", {
                        src: template.previewImage,
                        alt: template.name
                      }, null, 8, _hoisted_51)
                    ]),
                    _hoisted_52
                  ], 10, _hoisted_49))
                }), 128))
              ]),
              _hoisted_53
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_54, [
          (currentStep.value > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-secondary btn-lg",
                onClick: prevStep,
                disabled: isUploading.value
              }, [
                _hoisted_56,
                _createTextVNode(" Back ")
              ], 8, _hoisted_55))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-outline-secondary btn-lg",
                onClick: hide,
                disabled: isUploading.value
              }, " Cancel ", 8, _hoisted_57)),
          _hoisted_58,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-lg",
            onClick: nextStep,
            disabled: !canProceed.value || isUploading.value
          }, [
            (isUploading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                  _hoisted_61,
                  _createTextVNode(" Uploading... ")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_62, [
                  _createTextVNode(_toDisplayString(isLastStep.value ? "Create Resume" : "Continue") + " ", 1),
                  (!isLastStep.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_63))
                    : _createCommentVNode("", true)
                ]))
          ], 8, _hoisted_59)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})